import { Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const splitFeatures = (text) => (text || "").split("\n").map((s) => s.trim()).filter(Boolean);

export const PackageCards = ({ packages = [], selected, onSelect, testPrefix = "register-package-card" }) => {
  const { t, tr } = useLang();
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
      {packages.map((p, i) => {
        const active = selected === p.id;
        return (
          <button
            type="button"
            key={p.id}
            onClick={() => onSelect?.(p.id)}
            data-testid={`${testPrefix}-${p.id}`}
            style={{ animationDelay: `${i * 90}ms` }}
            className={`animate-fade-up group relative flex flex-col rounded-2xl border-2 bg-card p-6 text-left transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl ${active ? "border-primary shadow-lg shadow-primary/10" : "border-border hover:border-primary/40"}`}
          >
            {active && (
              <span className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <Check className="h-4 w-4" />
              </span>
            )}
            <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">0{i + 1}</span>
            <span className="mt-2 text-xl font-bold">{tr(p.name)}</span>
            {p.reward && (
              <>
                <span className="mt-4 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t("reward")}</span>
                <span className="text-3xl font-extrabold tracking-tight text-amber-600 dark:text-amber-400" data-testid={`${testPrefix}-${p.id}-reward`}>{p.reward}</span>
              </>
            )}
            <span className="mt-3 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{t("reg_payment")}</span>
            <span className="text-xl font-extrabold tracking-tight text-primary" data-testid={`${testPrefix}-${p.id}-price`}>{p.price}</span>
            <ul className="mt-5 flex-1 space-y-2.5">
              {splitFeatures(tr(p.features)).map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" />{f}
                </li>
              ))}
            </ul>
            <span className={`mt-6 rounded-full py-2.5 text-center text-sm font-bold transition-colors ${active ? "bg-primary text-primary-foreground" : "bg-muted group-hover:bg-primary group-hover:text-primary-foreground"}`}>
              {active ? t("selected") : t("select_package")}
            </span>
          </button>
        );
      })}
    </div>
  );
};
